import type { ToolProvider } from '@/backend/types'
import type { ToolRegistryItem } from '@/modules/Project/Tools/tool-types'

/**
 * Returns the registry item with its provider changed to the given provider. This is used
 * for tools that are routed through different providers, e.g. Claude tools via Vertex AI
 * or OpenAI tools via Azure.
 */
export const changeProvider = (
  registryItem: ToolRegistryItem,
  provider: ToolProvider,
): ToolRegistryItem => ({
  ...registryItem,
  provider,
})
